/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from 'react';
import {
  Upload, Button, notification,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { api } from '@seaoil/component-lib';

const {
  REACT_APP_MYSEAOIL_BASE_URL: MYSEAOIL_BASE_URL,
} = process.env;

const { mySEAOIL } = api;

async function uploadFile({ dataset, file }) {
  return new Promise((resolve, reject) => {
    mySEAOIL
      .file
      .upload({
        dataset,
        file,
        onSuccess(result) {
          resolve(result);
        },
        onError(error) {
          reject({
            error,
          });
        },
      })
      .send();
  });
}

function FileUploader({
  config: {
    accept,
    dataset,
    maxAttachment,
  },
  onUpload,
  onRemove,
  onFinishUpload,
}) {
  const [
    {
      fileList,
      uploading,
    },
    setState,
  ] = useState({
    fileList: [],
    uploading: false,
  });
  const noOfAttachments = maxAttachment || 50;
  // default accepted file types
  const acceptedFileTypes = (() => {
    if (accept && Array.isArray(accept)) {
      return accept.join(',');
    }

    return [
      '.doc', '.docx', '.odm', '.odt',
      '.xls', '.xlsx', '.ods', '.ots',
      '.csv',
      '.pdf',
      '.jpg', 'jpeg', '.png',
    ].join(',');
  })();

  const handleUpload = async () => {
    if (fileList.length > noOfAttachments) {
      notification.info(`Cannot upload more than ${noOfAttachments} at a time.`);
      return;
    }

    setState((prevState) => ({
      ...prevState,
      uploading: true,
    }));

    try {
      notification.info({ message: 'Uploading your files. Please wait a sec...' });
      const results = await Promise.all(fileList.map((file) => uploadFile({ dataset, file })));

      onFinishUpload(results.map((result) => {
        const { s3_file_path } = result;
        const link = `${MYSEAOIL_BASE_URL}/view-file/?filepath=${encodeURIComponent(s3_file_path)}`;
        return { ...result, link };
      }));
      notification.success({ message: 'Uploaded successfully.' });
    } catch (e) {
      notification.error({ message: 'Upload failed' });
    } finally {
      setState((prevState) => ({
        ...prevState,
        uploading: false,
      }));
    }
  };

  useEffect(() => {
    if (!fileList || !fileList.length) {
      return;
    }
    handleUpload();
  }, [fileList]);

  useEffect(() => {
    onUpload(uploading);
  }, [uploading]);

  return (
    <>
      <Upload
        accept={acceptedFileTypes}
        multiple
        fileList={fileList}
        beforeUpload={(file) => {
          setState((state) => ({
            fileList: [...state.fileList, file],
          }));
          return false;
        }}
        onRemove={(file) => {
          const index = fileList.indexOf(file);
          const newFileList = fileList.slice();
          newFileList.splice(index, 1);

          onRemove(newFileList);

          setState((state) => ({
            ...state,
            fileList: newFileList,
          }));
        }}
      >
        <Button disabled={uploading}>
          {(() => {
            if (uploading) {
              return uploading ? 'Uploading' : 'Upload';
            }

            return (
              <>
                <UploadOutlined />
                {' '}
                Select File(s)
              </>
            );
          })()}
        </Button>
      </Upload>
    </>
  );
}

export default FileUploader;
